import { Stack, Typography } from "@mui/material";
import type {
  EntityFieldConfiguration,
  NumberEntityFieldConfiguration,
  PercentEntityFieldConfiguration,
} from "../../../../../api/types/objectTypes";
import { allNumberScaleFormats } from "../../../../../api/types/objectTypes";
import NumberPrecisionSelect from "../../../../common/NumberPrecisionSelect";
import ScaleFormatSelect from "./ScaleFormatSelect";

interface Props {
  fieldConfiguration: NumberEntityFieldConfiguration | PercentEntityFieldConfiguration;
  readOnly?: boolean;
  onChange: (fieldConfiguration: EntityFieldConfiguration) => void;
}

const NumberFieldConfigEditor = ({ fieldConfiguration, readOnly, onChange }: Props) => {
  return (
    <Stack spacing={1} sx={{ pt: 2 }}>
      <Typography variant="subtitle2">Formatting</Typography>
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Typography color="textSecondary">Precision</Typography>
        <NumberPrecisionSelect
          maxPrecision={6}
          precision={fieldConfiguration.precision || 0}
          disabled={readOnly}
          onPrecisionChange={(precision) => onChange({ ...fieldConfiguration, precision })}
          sx={{ width: "12rem" }}
        />
      </Stack>
      {fieldConfiguration.$type === "Number" && (
        <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
          <Typography color="textSecondary">Display Style</Typography>
          <ScaleFormatSelect
            value={fieldConfiguration.scaleFormat}
            options={allNumberScaleFormats}
            disabled={readOnly}
            onChange={(scaleFormat) => onChange({ ...fieldConfiguration, scaleFormat })}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default NumberFieldConfigEditor;
